import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Navigate, Outlet } from "react-router-dom";
import { AppShell } from "../components/layout/AppShell.js";
import { EngoLogo } from "../components/brand/EngoLogo.js";
import { api } from "../lib/api.js";

export function ShellLayout() {
  const { t } = useTranslation();
  const { data, isPending, isError } = useQuery({
    queryKey: ["auth", "me"],
    queryFn: () => api.me(),
    retry: false,
    staleTime: 60_000,
  });

  if (isPending) {
    return (
      <div className="relative z-10 flex min-h-screen flex-col items-center justify-center gap-3">
        <EngoLogo size={44} className="animate-pulse" />
        <p className="font-display text-lg font-semibold text-[var(--text-primary)]">Engo</p>
        <p className="text-sm text-[var(--text-secondary)]">{t("brand.tagline")}</p>
      </div>
    );
  }

  if (isError || !data) {
    return <Navigate to="/login" replace />;
  }

  return (
    <AppShell user={data}>
      <Outlet />
    </AppShell>
  );
}
